// extracted by mini-css-extract-plugin
export default {"campaigns":"Campaigns_campaigns__10PEh","base":"Campaigns_base__3d+CP","header":"Campaigns_header__u7T+x","controls":"Campaigns_controls__pjQo4","buttons":"Campaigns_buttons__id1Q6"};